import Client from "fhir-kit-client";
import { Patient } from "fhir/r4";
import { FunctionComponent, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import AcesoPage from "src/components/AcesoPage/AcesoPage";
import PatientForm from "src/components/PatientForm/PatientForm";

const PatientCreation: FunctionComponent = () => {

    ///////////////////////////////////
    //             State             //
    /////////////////////////////////

    const [loading, setLoading] = useState(false);

    /////////////////////////////////////
    //             Client               //
    //////////////////////////////////

    const fhirClient = new Client({
        baseUrl: process.env.REACT_APP_FHIR_URL ?? "fhir",
    });

    /////////////////////////////////////
    //             Actions               //
    //////////////////////////////////

    const navigate = useNavigate();

    const onDetails = useCallback((id: string) => {
        navigate("/Aceso/PatientsViewer/" + id);
    }, [navigate]);

    /**
* View the report details, ie redirect to the report page.
* 
* @param id ID of the Report to display.
*/
    function viewPatientsDetails(id: string) {
        onDetails(id);
    }

    async function createPatient(patient: Patient) {
        const requestHeaders: HeadersInit = new Headers();
        requestHeaders.set('Prefer', 'return=representation');
        try {
            setLoading(true);
            const response = await fhirClient.create({
                resourceType: "Patient",
                body: patient,
                headers: requestHeaders,
            });
            viewPatientsDetails(response.id);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    }

    /////////////////////////////////////
    //             Content               //
    //////////////////////////////////

    return (
        <AcesoPage loading={loading} titleKey='title.patientcreation' needsLogin={true}>
            <>
                <PatientForm
                    displayButtons={true}
                    patientSubmit={(patient) => { createPatient(patient); }}
                />
            </>
        </AcesoPage >
    );
};

export default PatientCreation;
